module.exports = __webpack_public_path__ + "img/deliveboo-2.873eb66e.png";